import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMSpaceResource {
  
  static getSpace(id, completion){
    const apiClient = new SMRestClient();
    apiClient.get("/1/spaces/" + id + ".json").
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static deleteSpace(id, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/spaces/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    apiClient.destroy(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static getSpaces(queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/spaces.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static postSpace(formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/spaces.json" + q;  
    const apiClient = new SMRestClient();
    const request = apiClient.post(url, formData);
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
      return request;
  }
  
  static updateSpace(id, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/spaces/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    const request = apiClient.patch(url, formData);
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
    return request;
  }
  
  static getReputations(id, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/spaces/"+ id +"/reputations.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
}
export default SMSpaceResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMSpaceResource.js